<app-popover [reference]="popoverRef" width="200px" #popover (positionChanged)="changePosition($event)">
    <div class="bg-white rounded shadow-xl p-4" [ngClass]="popoverPosition">
        <ng-content></ng-content>
    </div>
</app-popover>